import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Android & Apple <span>Music App</span> Development
            </h2>
            <p>
              At Tekrevol, we specialize in developing custom music apps to suit
              both types of OS. Whether you want your music apps to rock on
              iPhones or work smoothly on Android smartphones, we have
              customized approaches to both.
            </p>
            <p>
              Android music app development is less costly, but can allow you to
              acquire a greater variety of features because of the platform’s
              flexibility towards incorporating radical, new elements.
            </p>
            <p>
              Apple music app development is more inclined towards affording
              users with a stellar app experience. Here you will get the most
              modern music app design that looks chic and is incredible to
              engage with on all levels.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolution_sol_img text-center"
          >
            <StaticImage
              src="../../../images/solution/music/revolution.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={470}
              height={720}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
